import React, {PropTypes} from 'react'
import Link from 'react-router/lib/Link'
import {Form} from 'react-redux-form/immutable'
import {Fieldset} from 'react-gridforms'

import FieldGroupRow from 'components/FieldGroupRow'
const req = val => val && val.length

const validators = {
  username: {req},
  password: {req},
}

// stateless react function
const FormLogin = ({pending, onSubmit}) => {
  const loginText = pending ? 'Login...' : 'Login'

  return (
    <Form
      model="loginState"
      className="grid-form"
      validators={validators}
      onSubmit={onSubmit}
    >
      <Fieldset legend="Student Login:">
        <FieldGroupRow
          model=".username"
          label="Username"
          autoCapitalize="off"
          autoFocus
          required
        />
        <FieldGroupRow
          model=".password"
          label="Password"
          type="password"
          required
        />
        <p className="m-t-20 text-right">
          <Link to="/forgot-password" className="btn-link">
            <em>Forgot your password?</em>
          </Link>
          {' '}
          <button type="submit" className="btn btn-primary" disabled={pending}>
            {loginText}
          </button>
        </p>
      </Fieldset>
    </Form>
  )
}

FormLogin.propTypes = {
  pending: PropTypes.bool,
  onSubmit: PropTypes.func.isRequired,
}

export default FormLogin



// WEBPACK FOOTER //
// ./src/containers/Auth/Login/form-login.js